import { Controller } from "@hotwired/stimulus"
import { FetchRequest } from "@rails/request.js"

export default class extends Controller {
  static targets = ["content", "spinner"]
  static values = {
    url: String,
    loaded: { type: Boolean, default: false }
  }

  declare readonly contentTarget: HTMLElement
  declare readonly spinnerTarget?: HTMLElement
  declare readonly urlValue: string
  declare loadedValue: boolean

  async loadCages(event: Event): Promise<void> {
    event.preventDefault()

    if (this.loadedValue) return

    if (this.spinnerTarget) {
      this.spinnerTarget.classList.remove('d-none')
    }

    try {
      const request = new FetchRequest("get", this.urlValue, {
        responseKind: "turbo-stream"
      })

      const response = await request.perform()

      if (!response.ok) throw new Error("Failed to load data")

      this.loadedValue = true
    } catch (error) {
      console.error("Error:", error)
      this.contentTarget.innerHTML = `
        <div class="alert alert-danger">
          Failed to load content. Please try again.
        </div>
      `
    } finally {
      if (this.spinnerTarget) {
        this.spinnerTarget.classList.add('d-none')
      }
    }
  }
}
